import { isAuthenticated$ } from '@op/services'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { setView as setLandingView, setRedirect, setSSO } from '../../reducers/landing.slice'
import { useAppDispatch } from '../../types'

export const AuthRedirect = () => {
	const d = useAppDispatch()
	const isAuthenticated = useSelector(isAuthenticated$)

	// We clear the redirect, or any specified `LandingView`, and SSO, once we've authenticated
	useEffect(() => {
		if (isAuthenticated) {
			d(setLandingView(null))
			d(setRedirect(null))
			d(setSSO(null))
		}
	}, [isAuthenticated])

	return null
}
